export const PAL = [["1003", "Jaune de sécurité", "#F9A800"], ["1015", "Ivoire clair", "#E6D2B5"], ["1018", "Jaune zinc", "#FACA30"], ["1021", "Jaune colza", "#F6B600"], ["1023", "Jaune signalisation", "#F7B500"], ["2004", "Orangé pur", "#E25303"], ["2008", "Orangé rouge clair", "#E86A2D"], ["2009", "Orangé signalisation", "#D84E1E"], ["2011", "Orangé foncé", "#EC6500"], ["3000", "Rouge feu", "#A72920"], ["3003", "Rouge rubis", "#861A22"], ["3005", "Rouge vin", "#59191F"], ["3014", "Vieux rose", "#CB7375"], ["3020", "Rouge signalisation", "#BB1E10"], ["4005", "Lilas bleu", "#76689A"], ["4006", "Pourpre signalisation", "#903373"], ["5002", "Bleu outremer", "#00387B"], ["5005", "Bleu de sécurité", "#005387"], ["5010", "Bleu gentiane", "#004F7C"], ["5012", "Bleu clair", "#0089B6"], ["5015", "Bleu ciel", "#007CB0"], ["5017", "Bleu signalisation", "#005B8C"], ["5024", "Bleu pastel", "#6093AC"], ["6005", "Vert mousse", "#114232"], ["6018", "Vert jaune", "#61993B"], ["6024", "Vert signalisation", "#008351"], ["6029", "Vert menthe", "#006F3D"], ["6037", "Vert pur", "#009A3E"], ["7001", "Gris argent", "#8F999F"], ["7016", "Gris anthracite", "#373F43"], ["7021", "Gris noir", "#2E3234"], ["7035", "Gris clair", "#CBD0CC"], ["8017", "Brun chocolat", "#44322D"], ["9001", "Blanc crème", "#E9E0D2"], ["9005", "Noir foncé", "#0E0E10"], ["9006", "Aluminium blanc", "#A1A1A0"], ["9010", "Blanc pur", "#F1ECE1"], ["9016", "Blanc signalisation", "#F1F0EA"]];

export const ORIGIN = 'origine';

export const ZONES = [
  { id: 1, key: 'bases', name: 'Bases', name_en: 'Chainstays' },
  { id: 2, key: 'haubans', name: 'Haubans', name_en: 'Seatstays' },
  { id: 3, key: 'cadre', name: 'Milieu du cadre', name_en: 'Main frame' },
  { id: 4, key: 'plateforme', name: 'Plateforme', name_en: 'Platform' },
  { id: 5, key: 'fourche', name: 'Fourche', name_en: 'Fork' },
];
export const STICKER_ZONE = { id: 6, key: 'stickers', name: 'Stickers', name_en: 'Stickers' };

export const DEFAULT_PAINT = { bases: ORIGIN, haubans: ORIGIN, cadre: ORIGIN, plateforme: ORIGIN, fourche: ORIGIN, stickers: 'blanc' };

const BASE_LIN = { 1: [0.00091, 0.17144, 0.00091], 2: [0.7913, 0.7991, 0.7991], 3: [0.00439, 0.00439, 0.00478], 4: [0.53948, 0.00857, 0.00913], 5: [0.00304, 0.13287, 0.00212] };
export const ORIG_HEX = { bases: '#1f7a14', haubans: '#e8e9e9', cadre: '#121213', plateforme: '#c41c1d', fourche: '#0b6505' };
export const STICKER = {
  blanc: { name: 'Blanc', name_en: 'White', hex: '#F4F4F2', lin: [0.8, 0.8, 0.8] },
  noir: { name: 'Noir', name_en: 'Black', hex: '#111111', lin: [0.006, 0.006, 0.006] },
};

export const byCode = Object.fromEntries(PAL.map(([code, name, hex]) => [code, { code, name, hex }]));

export const isPaintSurcharged = (paint) => {
  if (ZONES.every((z) => paint[z.key] === ORIGIN)) return false;
  return new Set(ZONES.map((z) => (paint[z.key] === ORIGIN ? `o-${z.key}` : paint[z.key]))).size >= 2;
};

export const paintToQuery = (paint) => ZONES.map((z) => `${z.key}=${paint[z.key]}`).join('&') + `&stickers=${paint.stickers}`;

export function paintFromHash() {
  const p = new URLSearchParams(window.location.hash.slice(1));
  const s = { ...DEFAULT_PAINT };
  let ok = false;
  ZONES.forEach((z) => { const v = p.get(z.key); if (v && (byCode[v] || v === ORIGIN)) { s[z.key] = v; ok = true; } });
  const st = p.get('stickers');
  if (st && STICKER[st]) { s.stickers = st; ok = true; }
  return ok ? s : null;
}

export const zoneLabel = (paint, key, lang = 'fr') => {
  if (key === 'stickers') { const s = STICKER[paint.stickers]; return { hex: s.hex, code: '', name: lang === 'en' ? s.name_en : s.name }; }
  const c = paint[key];
  if (c === ORIGIN || !byCode[c]) return { hex: ORIG_HEX[key], code: '', name: lang === 'en' ? 'Original colour' : "Couleur d'origine" };
  return { hex: byCode[c].hex, code: `RAL ${c}`, name: byCode[c].name };
};

export const paintSummary = (paint, lang = 'fr') => [...ZONES, STICKER_ZONE].map((z) => {
  const l = zoneLabel(paint, z.key, lang);
  return [lang === 'en' ? z.name_en : z.name, l.code ? `${l.code} · ${l.name}` : l.name];
});

export const paintText = (paint) => 'Folgo — configuration couleur\n' + paintSummary(paint).map(([k, v]) => `${k} : ${v.replace(' · ', ' ')}`).join('\n');

const s2l = (v) => { v /= 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
const L2S = new Uint8ClampedArray(4096);
for (let i = 0; i < 4096; i++) { const v = i / 4095; L2S[i] = Math.round(255 * (v <= 0.0031308 ? v * 12.92 : 1.055 * Math.pow(v, 1 / 2.4) - 0.055)); }
const toS = (v) => L2S[v >= 1 ? 4095 : v <= 0 ? 0 : (v * 4095) | 0];
const hexLin = (h) => [1, 3, 5].map((i) => s2l(parseInt(h.slice(i, i + 2), 16)));

export const X0 = 4;
export const Y0 = 395;
export const VIEW_W = 1996;
export const VIEW_H = 740;

function pixels(img) {
  const c = document.createElement('canvas'); c.width = VIEW_W; c.height = VIEW_H;
  const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, -X0, -Y0);
  return x.getImageData(0, 0, VIEW_W, VIEW_H).data;
}

export function buildRenderData(srcImg, bgImg, dataImg) {
  const SRC = pixels(srcImg), BGD = pixels(bgImg), dd = pixels(dataImg);
  const N = VIEW_W * VIEW_H;
  const LAB = new Uint8Array(N), ALP = new Float32Array(N), DSH = new Float32Array(N), SPC = new Float32Array(N), OWN = new Uint8Array(N), WR = new Float32Array(N);
  for (let i = 0, j = 0; i < N; i++, j += 4) {
    const r = dd[j]; LAB[i] = r >> 5;
    if (!(r >> 5)) { OWN[i] = r & 31; WR[i] = dd[j + 1] / 255; }
    ALP[i] = (r & 31) / 31; DSH[i] = dd[j + 1] / 255;
    const s = dd[j + 2] / 255; SPC[i] = LAB[i] === 6 ? s : s * s;
  }
  return { SRC, BGD, LAB, ALP, DSH, SPC, OWN, WR, N, out: new ImageData(VIEW_W, VIEW_H) };
}

export function renderPaint(rd, paint, canvas) {
  const { SRC, BGD, LAB, ALP, DSH, SPC, OWN, WR, N, out } = rd;
  const o = out.data; o.set(SRC);
  const T = {};
  ZONES.forEach((z) => { const c = paint[z.key]; T[z.id] = byCode[c] ? hexLin(byCode[c].hex) : null; });
  const fr = T[3] || BASE_LIN[3], st = STICKER[paint.stickers].lin;
  const stickerUntouched = !T[3] && paint.stickers === 'blanc';
  for (let i = 0, j = 0; i < N; i++, j += 4) {
    const z = LAB[i];
    if (!z) {
      const w = OWN[i];
      if (w && T[w]) { const k = WR[i]; for (let c = 0; c < 3; c++) { const v = o[j + c], b = BGD[j + c]; if (b < v) o[j + c] = v + k * (b - v); } }
      continue;
    }
    if (z >= 6) {
      if (stickerUntouched) continue;
      const a = ALP[i], geo = SPC[i];
      o[j] = toS(a * st[0] + (1 - a) * fr[0] * geo); o[j + 1] = toS(a * st[1] + (1 - a) * fr[1] * geo); o[j + 2] = toS(a * st[2] + (1 - a) * fr[2] * geo);
      continue;
    }
    const t = T[z];
    if (!t) continue;
    const d = DSH[i], s = SPC[i];
    const r = toS(t[0] * d + s), g = toS(t[1] * d + s), b = toS(t[2] * d + s);
    const a = ALP[i];
    if (a >= 0.999) { o[j] = r; o[j + 1] = g; o[j + 2] = b; } else { o[j] = a * r + (1 - a) * BGD[j]; o[j + 1] = a * g + (1 - a) * BGD[j + 1]; o[j + 2] = a * b + (1 - a) * BGD[j + 2]; }
  }
  canvas.getContext('2d').putImageData(out, 0, 0);
}

export function zoneAt(rd, canvas, e) {
  if (!rd) return 0;
  const r = canvas.getBoundingClientRect();
  const x = Math.floor(((e.clientX - r.left) / r.width) * VIEW_W), y = Math.floor(((e.clientY - r.top) / r.height) * VIEW_H);
  if (x < 0 || y < 0 || x >= VIEW_W || y >= VIEW_H) return 0;
  for (let dy = -4; dy <= 4; dy += 2) {
    for (let dx = -4; dx <= 4; dx += 2) {
      const xx = x + dx, yy = y + dy;
      if (xx < 0 || yy < 0 || xx >= VIEW_W || yy >= VIEW_H) continue;
      const z = rd.LAB[yy * VIEW_W + xx];
      if (z) return z > 6 ? 6 : z;
    }
  }
  return 0;
}
